module.exports = __webpack_public_path__ + "img/Mobile_order_hit01.8f5e6841.png";